<template>
  <input hidden :value="value || checked" :checked="checked" :type="type" :name="name" class="form__hiddenfield" />
</template>

<script>
export default {
  props: {
    name: {type: String, required: true},
    type: {type: String, default: 'text'},
    value: {},
    checked: {}
  }
}
</script>

<style lang="sass">
.form__hiddenfield
  position: absolute
  visibility: hidden
</style>